import {
  Badge,
  Button,
  Center,
  Flex,
  Heading,
  Image,
  Link,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

export default function Licious() {
  return (
    <Center py={6}>
      <Stack
        borderWidth="1px"
        borderRadius="lg"
        w={{ sm: '100%', md: '50%',lg:"80%",xl:"80%" }}
        
        direction={{ base: 'column', md: 'column',sm:"column",lg:"row",xl:"row"  }}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={'2xl'}
        padding={4}>
        <Flex flex={1} bg="blue.200">
          <Image
             _hover={{
              bg:"blue"
            }}        
            boxSize="100%"
            src={
              'Licious.png'
            }
          />
        </Flex>
        <Stack
          flex={1}
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          p={1}
          pt={2}>
          <Heading fontSize={'3xl'} fontFamily={'body'}>
            Licious Clone
          </Heading>
         
          <Text
            textAlign={'center'}
            color={useColorModeValue('gray.700', 'gray.400')}
            px={3}>
             Licious is a Bengaluru-based meat and seafood brand. The company serves the best, fresh and clean fish, chicken, meat, and eggs online. Licious works on a farm to fork model owning the entire back-end supply chain and the cold chain. A separate recipe section is also present in their App. It helps the customers to cook delicious dishes. And also teaches the exotic chef style.
          </Text>
          <Stack align={'center'} justify={'center'} direction={'row'} mt={6}>
            <Badge
              px={2}
              py={1}
              bg={useColorModeValue('gray.50', 'gray.800')}
              fontWeight={'400'}>
              #HTML
            </Badge>
            <Badge
              px={2}
              py={1}
              bg={useColorModeValue('gray.50', 'gray.800')}
              fontWeight={'400'}>
              #CSS
            </Badge>
            <Badge
              px={2}
              py={1}
              bg={useColorModeValue('gray.50', 'gray.800')}
              fontWeight={'400'}>
              #JAVASCRIPT
            </Badge>
          </Stack>

          <Stack
            width={'100%'}
            mt={'2rem'}
            direction={'row'}
            padding={2}
            justifyContent={'space-around'}
            alignItems={'center'}>
            <a href='https://github.com/vishnu9651/lucious' target="_blank">
            <Button
              flex={1}
              fontSize={'sm'}
              rounded={'full'}
              _focus={{
                bg: 'gray.200',
              }}>
              Code
            </Button>
            </a>
            <a href='https://tiny-alpaca-6357a7.netlify.app/index.html' target="_blank">
            <Button
              flex={1}
              fontSize={'sm'}
              rounded={'full'}
              bg={'blue.400'}
              color={'white'}
              boxShadow={
                '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
              }
              _hover={{
                bg: 'blue.500',
              }}
              _focus={{
                bg: 'blue.500',
              }}>
              View
            </Button>
            </a>
          </Stack>
        </Stack>
      </Stack>
    </Center>
  );
}


// import {
//     Badge,
//     Button,
//     Center,
//     Flex,
//     Heading,
//     Image,
//     Link,
//     Stack,
//     Text,
//     useColorModeValue,
//   } from '@chakra-ui/react';
  
//   export default function Licious() {
//     return (
//       <Center py={6}>
//         <Stack
//           borderWidth="1px"
//           borderRadius="lg"
//           w={{ sm: '100%', md: '50%',lg:"80%",xl:"80%" }}
          
//           direction={{ base: 'column', md: 'column',sm:"column",lg:"row",xl:"row"  }}
//           bg={useColorModeValue('white', 'gray.900')}
//           boxShadow={'2xl'}
//           padding={4}>
//           <Flex flex={1} bg="blue.200">
//             <Image
//               objectFit="cover"
//               boxSize="100%"
//               src={
//                 'LiciousPoster.png'
//               }
//             />
//           </Flex>
//           <Stack
//             flex={1}
//             flexDirection="column"
//             justifyContent="center"
//             alignItems="center"
//             p={1}
//             pt={2}>
//             <Heading fontSize={'3xl'} fontFamily={'body'}>
//               Lecious Clone
//             </Heading>
            
//             <Text
//               textAlign={'center'}
//               color={useColorModeValue('gray.700', 'gray.400')}
//               px={3}>
//               Licious is a Bengaluru-based meat and seafood brand. The company serves the best, fresh and clean fish, chicken, meat, and eggs online.
              
//             </Text>
//             <Stack align={'center'} justify={'center'} direction={'row'} mt={6}>
//               <Badge
//                 px={2}
//                 py={1}
//                 bg={useColorModeValue('gray.50', 'gray.800')}
//                 fontWeight={'400'}>
//                 #JavaScript
//               </Badge>
//               <Badge
//                 px={2}
//                 py={1}
//                 bg={useColorModeValue('gray.50', 'gray.800')}
//                 fontWeight={'400'}>
//                 #Html
//               </Badge>
//               <Badge
//                 px={2}
//                 py={1}
//                 bg={useColorModeValue('gray.50', 'gray.800')}
//                 fontWeight={'400'}>
//                 #CSS
//               </Badge>
//             </Stack>
  
//             <Stack
//               width={'100%'}
//               mt={'2rem'}
//               direction={'row'}
//               padding={2}
//               justifyContent={'space-around'}
//               alignItems={'center'}>

// <a href='https://github.com/vishnu9651/lucious' target="_blank">
//               <Button
//                 flex={1}
//                 fontSize={'sm'}
//                 rounded={'full'}
//                 _focus={{
//                   bg: 'gray.200',
//                 }}>
//                 Code
//               </Button>
//               </a>
//               <a href='https://tiny-alpaca-6357a7.netlify.app/index.html' target="_blank">
//               <Button
//                 flex={1}
//                 fontSize={'sm'}
//                 rounded={'full'}
//                 bg={'blue.400'}
//                 color={'white'}
//                 boxShadow={
//                   '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
//                 }
//                 _hover={{
//                   bg: 'blue.500',
//                 }}
//                 _focus={{
//                   bg: 'blue.500',
//                 }}>
//                 View
//               </Button>
//               </a>
//             </Stack>
//           </Stack>
//         </Stack>
//       </Center>
//     );
//   }